import { BlogData } from "../../blogData/BlogData";


const initialState={
        blogs:BlogData,
        filters:{
                category:'all',
                author:'all',
                query:''
        }
}
export default initialState;